export const POS_ORDER_HISTORIES_LOADING = 'POS_ORDER_HISTORIES_LOADING';
export const POS_ORDER_HISTORIES_FULFILLED = 'POS_ORDER_HISTORIESS_FULFILLED';

export const POS_ORDER_HISTORY_FULFILLED = 'POS_ORDER_HISTORY_FULFILLED';
export const POS_ORDER_HISTORY_CANCELLED = 'POS_ORDER_HISTORY_CANCELLED';
